<div class="table-responsive small">
    <ng-container *ngIf="!isReportLoading && surveys.length === 0">
        <div class="loading-cover">
            There are no surveys needing approval
        </div>
    </ng-container>
    <p-table *ngIf="!isReportLoading && surveys.length > 0" [value]="surveys" [loading]="isReportLoading" styleClass="p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th scope="col" *ngIf="this.accountInfo?.isAdmin">Rep</th>
                <th scope="col">Matter Number</th>
                <th scope="col">Matter Name</th>
                <th scope="col">Survey Type</th>
                <th scope="col">Survey Sent</th>
                <th scope="col">Survey Response</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-i="rowIndex" , let-m>
            <tr>
                <td *ngIf="this.accountInfo?.isAdmin"><span data-private>{{ m.clientRepName }}</span></td>
                <td>
                    <a class="ms-1" [routerLink]="['/matters/details', m.caseId, m.surveyTypeId, m.contactMonth, m.contactYear]">{{ m.caseNumber }}</a>
                </td>
                <td><span data-private>{{ m.caseName }}</span></td>
                <td>{{ m.surveyType }}</td>
                <td>{{ m.surveySentDate! | formatUtcDate }}</td>
                <td>{{ m.surveyResponseDate | formatUtcDate }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
